import { Component, Input, SimpleChanges, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { formatDistance } from 'date-fns';
import { ProjectViewModel } from '../../../models-views/project.view.model';
import { AppCommon } from '../../../providers/app-common';
import { QuickAddService } from '../../../services/quick-add.service';
import { Subject, takeUntil } from 'rxjs';
import { QuillCustomServices } from '../../../providers/quill-config';
 

@Component({
  selector: 'app-cpd-overview',
  standalone: false,
  templateUrl: './cpd-overview.component.html',
  styleUrl: './cpd-overview.component.scss'
})
export class CpdOverviewComponent {
  @Input('desc') desc:any
  @Input('projectId') projectId:any
  @Input('UIType') UIType:any = true
  private destroy$ = new Subject<boolean>();
  commentDataList = []
  @ViewChild('projectCommentsContainer') projectCommentsContainer: ElementRef;
  loggedInUser :any;
  messageInput = '';
  quillConfig: any;
  
 constructor(private vm:ProjectViewModel , private quickAddService: QuickAddService,private quilservice:QuillCustomServices){
  this.vm.cpdOverviewComponent = this
  this.loggedInUser = AppCommon.getloggedInObject().user
  this.vm.commentList.pipe(takeUntil(this.destroy$)).subscribe(data => {
    const results = data?.results || [];
    this.commentDataList = [...results].sort((a: any, b: any) => {
      const t1 = new Date(a?.created_at || 0).getTime();
      const t2 = new Date(b?.created_at || 0).getTime();
      return t1 - t2;
    });
    this.scrollCommentsToBottom();
  })
  this.quillConfig = this.quilservice.QuillConfigDefault;
  this.vm.userListP.pipe(takeUntil(this.destroy$)).subscribe((data:any) => {
        this.quilservice.setMentions(data)
  })
 }

 ngOnInit(): void {
  //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
  //Add 'implements OnInit' to the class.
  this.vm.getUserList(1,1000);
 }

 ngOnChanges(changes: SimpleChanges): void {
 
  if(changes['projectId']){
    this.vm.getProjectComment(this.projectId)
  }
 
 }
 
 
  
 getBase64Image(data: string){
  if(!data){
    return undefined;
  }
  return "data:image/png;base64," + data;
}
  
   

  sendMessage() {
    if (!this.messageInput.trim()) return;

    if (this.editingComment) {
      this.saveEditComment();
      return;
    }

    let Mess = {created_at:new Date().toISOString(),created_by_name:this.loggedInUser.first_name,created_by:this.loggedInUser.id,source_project:this.projectId,comment:this.messageInput}
    this.vm.createProjectComment(Mess)
    this.messageInput = '';
    this.scrollCommentsToBottom();
  }

  commentCreated(){
    this.vm.getProjectComment(this.projectId)
  }

  // ── Comment edit ─────────────────────────────────────────────
  editingComment: any = null;

  canEditComment(comment: any): boolean {
    if (comment.created_by !== this.loggedInUser?.id) return false;
    return (Date.now() - new Date(comment.created_at).getTime()) < 5 * 60 * 1000;
  }

  startEditComment(comment: any): void {
    this.editingComment = comment;
    this.messageInput = comment.comment;
    setTimeout(() => {
      const container = this.projectCommentsContainer?.nativeElement;
      if (container) container.scrollTop = container.scrollHeight;
    }, 50);
  }

  cancelEditComment(): void {
    this.editingComment = null;
    this.messageInput = '';
  }

  saveEditComment(): void {
    if (!this.messageInput?.trim()) return;
    this.vm.updateProjectComment({ id: this.editingComment.id, comment: this.messageInput });
    this.editingComment = null;
    this.messageInput = '';
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  ngAfterViewInit(): void {
    this.scrollCommentsToBottom();
  }

  private scrollCommentsToBottom(): void {
    setTimeout(() => {
      const container = this.projectCommentsContainer?.nativeElement;
      if (!container) return;
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          container.scrollTop = container.scrollHeight;
        });
      });
    }, 0);
  }

  isCurrentUser(created_by:number){
    return this.loggedInUser.id == created_by;
  }

}
